module.exports = __webpack_public_path__ + "assets/img/convertiv.addca9d5.svg";